import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useMainButtonStyles = makeStyles({
    button: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'inherit',
        paddingTop: tokens.spacingHorizontalM,
        marginTop: 'auto',
        fontSize: tokens.fontSizeBase300,
        backgroundColor: tokens.colorNeutralBackground1,
        width: 'max-content',
        ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalXL),
        ...shorthands.borderColor(tokens.colorNeutralBackground1),
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ...shorthands.border(tokens.strokeWidthThick),
        ':hover': {
            ...shorthands.borderColor(tokens.colorNeutralBackground1Hover)
        },
        '@media screen and (max-width: 768px)': {
            ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalS),
            fontSize: tokens.fontSizeBase200,
            lineHeight: tokens.lineHeightBase200
        }
    },
    outlinedWhiteText: {
        backgroundColor: 'transparent',
        ...shorthands.borderColor(tokens.colorNeutralBackground4),
        color: tokens.colorNeutralBackground4
    },
    outlinedBlackText: {
        backgroundColor: 'transparent',
        ...shorthands.borderColor(tokens.colorNeutralForeground1),
        color: tokens.colorNeutralForeground1,
        ':hover': {
            backgroundColor: tokens.colorNeutralBackgroundInverted,
            color: tokens.colorNeutralBackground4
        }
    },
    outlinedBlueText: {
        fontWeight: tokens.fontWeightRegular,
        ...shorthands.borderColor(tokens.colorBrandForegroundLink),
        color: tokens.colorBrandForegroundLink,
        backgroundColor: 'transparent',
        ':hover': {
            backgroundColor: 'unset',
            ...shorthands.borderColor(tokens.colorBrandForegroundLinkHover),
            color: tokens.colorBrandForegroundLinkHover,
            textShadow: 'var(--colorNeutralStroke1Hover) 0px 1px'
        }
    },
    soft: {
        backgroundColor: 'transparent',
        ...shorthands.borderColor(tokens.colorNeutralBackground3),
        color: tokens.colorNeutralForeground3,
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground3,
            color: tokens.colorNeutralForeground3
        }
    },
    primary: {
        backgroundColor: tokens.colorBrandForegroundLink,
        ...shorthands.borderColor(tokens.colorNeutralBackground4),
        color: tokens.colorNeutralBackground4
    },
    link: {
        fontWeight: tokens.fontWeightRegular,
        color: tokens.colorBrandForegroundLink,
        backgroundColor: 'transparent',
        ...shorthands.border(0),
        ':hover': {
            backgroundColor: 'unset',
            color: tokens.colorBrandForegroundLink,
            textShadow: 'var(--colorNeutralStroke1Hover) 0px 1px'
        }
    },
    redText: {
        fontWeight: tokens.fontWeightRegular,
        color: tokens.colorPaletteRedForeground3,
        backgroundColor: 'transparent',
        ...shorthands.border(0),
        ':hover': {
            backgroundColor: 'unset',
            color: tokens.colorPaletteRedForeground3,
            ...shorthands.textDecoration('underline'),

            '&:active': {
                backgroundColor: 'unset',
                color: tokens.colorPaletteRedForeground3
            }
        }
    },
    solidRed: {
        backgroundColor: tokens.colorPaletteRedForeground3,
        color: '#FFFFFF',
        ...shorthands.border(0),
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        fontWeight: tokens.fontWeightRegular,
        ':hover': {
            backgroundColor: tokens.colorPaletteRedForeground1,
            color: '#FFFFFF',
            fontWeight: tokens.fontWeightBold,
            '&:active': {
                backgroundColor: tokens.colorPaletteRedForeground3,
                color: '#FFFFFF',
                fontWeight: tokens.fontWeightRegular
            }
        }
    }
});
